import Layout from "../components/Layout";

function Details() {
  return (
    <Layout>
      <h1>Details</h1>
    </Layout>
  );
}

export default Details;